<script>
import Creator from "@app/pages/Creator.svelte";

</script>

<div>
    <Creator></Creator>
</div>
